import { Offcanvas } from "@/modules/core/components";
import { computed, ref } from "vue";

const isMainNavOffcanvasOpen = ref(false);
const mainNavOffcanvasRef = ref<InstanceType<typeof Offcanvas>>();

export const useMainNavOffcanvas = () => {
    return {
        mainNavOffcanvasRef,
        show: () => mainNavOffcanvasRef.value?.show(),
        toggle: () => mainNavOffcanvasRef.value?.toggle(),
        isActive: computed(() => mainNavOffcanvasRef.value?.isActive)
    }
}